'use client';
var styles = {"article":"DimmedLayer-module_article__9fXdf","show":"DimmedLayer-module_show__7kssg"};

export { styles as default };
